<mat-dialog-content>
  @if (rawErrors) {
    <div class="raw-errors">
      {{errors}}
    </div>
  }
  @if (parsedErrors) {
    <div class="validation-problems errors">
      @for (error of parsedErrors; track error) {
        <ul>
          <li>{{ error.userFriendlyMessage }}</li>
        </ul>
      }
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions class="flex-container-right-align">
  <div class="spacer"></div>
  <button class="flex-item-fixed-size" mat-raised-button [mat-dialog-close]="true">{{ 'common.buttons.close' | transloco }}</button>
</mat-dialog-actions>